// base
import React, { useEffect } from 'react';

// hooks
import { useIconControl } from 'hooks';

// libraries
import gsap from 'gsap';
import { useGLTF } from '@react-three/drei';

useGLTF.preload('/assets/models/icons/map_pointer/map_pointer.gltf');

export const MapPointer = (props) => {
  const { onClick, ...rest } = props;

  const { scene, nodes, materials } = useGLTF('/assets/models/icons/map_pointer/map_pointer.gltf');
  const { hovered, setHovered, iconRef } = useIconControl({
    onClick
  });

  useEffect(() => {
    scene.traverse((mesh) => {
      mesh.castShadow = true;
      mesh.receiveShadow = true;
    });

    if (!iconRef.current) return;

    const rotationTween = gsap.to(iconRef.current.rotation, {
      duration: 3,
      repeat: -1,
      yoyo: false,
      ease: 'none',
      y: Math.PI * 2
    });

    return () => {
      rotationTween.kill();
    };
  }, []);

  useEffect(() => {
    if (!iconRef.current) return;

    gsap.to(iconRef.current.scale, {
      duration: 0.5,
      x: hovered ? 11.5 : 10,
      y: hovered ? 11.5 : 10,
      z: hovered ? 11.5 : 10
    });
  }, [hovered]);

  return (
    <group
      {...rest}
      dispose={null}
      ref={iconRef}
      scale={[10, 10, 10]}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      onPointerDown={onClick}
    >
      <group position={[0, 5, 0]}>
        <group rotation={[-Math.PI / 2, 0, 0]}>
          <mesh
            geometry={nodes.pointer.geometry}
            material={materials.red_plastic}
            position={[0, 0, -5.001]}
          />
        </group>
      </group>
    </group>
  );
};
